import { render, staticRenderFns } from "./BulletinDeSalaireModal.vue?vue&type=template&id=36592975"
import script from "./BulletinDeSalaireModal.vue?vue&type=script&lang=ts"
export * from "./BulletinDeSalaireModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports